import { createSearchParams } from "react-router";
import { authHeader } from "../../utils/auth-header";
import { uuidv4 } from "../../utils/uuid";
import { autopilot } from "../autopilot/autopilot";
import { withContentTracking } from "../content-generation/track-content-generation";

/**
 * Generates a survey from a prompt, the same way Listen's dashboard prompt does,
 * and returns the search params for `/listen/survey/new`.
 * Listen opens the draft from localStorage by `key`.
 *
 * This is a copy of how it's done in the listen repo
 */
export async function generateSurvey(
  token: string,
  prompt: string,
  signal?: AbortSignal,
): Promise<string> {
  const { data, contentGenerationResultId } = await withContentTracking(
    token,
    { contentType: "survey", prompt },
    async () => {
      const { data: survey, error } = await autopilot.POST("/survey", {
        body: { prompt, mergeTags: ["company_name"] },
        ...authHeader(token),
        signal,
      });
      if (error) throw new Error(error.error);
      return survey;
    },
  );

  const key = uuidv4();
  localStorage.setItem("generatedSurvey", JSON.stringify({ [key]: data.data }));

  return createSearchParams({
    key,
    title: data.data.title ?? "New Survey",
    ...(contentGenerationResultId && { contentGenerationResultId }),
  }).toString();
}
